export const fmtINR = (n) =>
  "₹" + new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(n || 0);

export const fmtCr = (n) => {
  n = n || 0;
  if (n >= 10000000) return "₹" + (n / 10000000).toFixed(2) + " Cr";
  if (n >= 100000) return "₹" + (n / 100000).toFixed(2) + " L";
  return fmtINR(n);
};

export const fmtNum = (n) => new Intl.NumberFormat("en-IN").format(n || 0);

export const fmtDate = (s) =>
  s ? new Date(s).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—";

export const fmtDateTime = (s) =>
  s
    ? new Date(s).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" })
    : "—";

export const roleLabel = {
  super_admin: "Super Admin",
  client_admin: "Client Admin",
  manager: "Manager",
  agent: "Agent",
  auditor: "Auditor",
  pending: "Pending",
};
